import { TFunction } from "i18next";
import { ISelectListItem } from "../interfaces";
import { BrandType } from "../types";
import { AdditionalProductType } from "@bus/models";
import { link } from "fs";

export function getContractMonths(brand?: BrandType): number[] {
    const ContractMonths = {
        cupra: [24, 36, 48, 60],
        seat: [24, 36, 48, 60],
        audi: [24, 36, 48, 60],
        vw: [24, 36, 48, 60],
        vwn: [24, 36, 48, 60],
        skoda: [24, 36, 48, 60],
    };

    return ContractMonths[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}

export function getContractAnnuallyKms(brand?: BrandType): number[] {
    const ContractAnnuallyKms = {
        cupra: [10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000],
        seat: [10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000],
        audi: [10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000],
        vw: [10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000],
        vwn: [10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000],
        skoda: [10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000],
    };
    return ContractAnnuallyKms[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}

export function getContractServices(t?: TFunction, brand?: BrandType): ISelectListItem<string>[] {
    const ContractServices = {
        cupra: [
            {
                id: AdditionalProductType.TIRE_SERVICE,
                displayName: t ? t("question4page:services.options.tire-service.title") : "",
                value: AdditionalProductType.TIRE_SERVICE,
                icon: "",
                tooltip: t ? t("question4page:services.options.tire-service.description") : "",
                ariaLabel: t ? t("question4page:services.options.tire-service.ariaLabel") : "",
            },
            {
                id: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                displayName: t ? t("question4page:services.options.credit-protection-insurance.title") : "",
                value: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.credit-protection-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.credit-protection-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.credit-protection-insurance.link") : "",
                textLink: t ? t("question4page:services.options.credit-protection-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.MAINTENANCE,
                displayName: t ? t("question4page:services.options.service-and-inspection.title") : "",
                value: AdditionalProductType.MAINTENANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.service-and-inspection.description") : "",
                ariaLabel: t ? t("question4page:services.options.service-and-inspection.ariaLabel") : "",
                link: t ? t("question4page:services.options.service-and-inspection.link") : "",
                textLink: t ? t("question4page:services.options.service-and-inspection.textLink") : "",
            },
            {
                id: AdditionalProductType.MOTOR_INSURANCE,
                displayName: t ? t("question4page:services.options.motor-insurance.title") : "",
                value: AdditionalProductType.MOTOR_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.motor-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.motor-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.motor-insurance.link") : "",
                textLink: t ? t("question4page:services.options.motor-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_DRIVER,
                displayName: t ? t("question4page:services.options.safe-in-motion.title") : "",
                value: AdditionalProductType.INSURANCE_DRIVER,
                icon: "",
                tooltip: t ? t("question4page:services.options.safe-in-motion.description") : "",
                ariaLabel: t ? t("question4page:services.options.safe-in-motion.ariaLabel") : "",
                link: t ? t("question4page:services.options.safe-in-motion.link") : "",
                textLink: t ? t("question4page:services.options.safe-in-motion.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                displayName: t ? t("question4page:services.options.gap-events-insurance.title") : "",
                value: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.gap-events-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.gap-events-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.gap-events-insurance.link") : "",
                textLink: t ? t("question4page:services.options.gap-events-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_IDENTIFICATION,
                displayName: t ? t("question4page:services.options.securi-code.title") : "",
                value: AdditionalProductType.VEHICLE_IDENTIFICATION,
                icon: "",
                tooltip: t ? t("question4page:services.options.securi-code.description") : "",
                ariaLabel: t ? t("question4page:services.options.securi-code.ariaLabel") : "",
                link: t ? t("question4page:services.options.securi-code.link") : "",
                textLink: t ? t("question4page:services.options.securi-code.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                displayName: t ? t("question4page:services.options.capital-safe.title") : "",
                value: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.capital-safe.description") : "",
                ariaLabel: t ? t("question4page:services.options.capital-safe.ariaLabel") : "",
                link: t ? t("question4page:services.options.capital-safe.link") : "",
                textLink: t ? t("question4page:services.options.capital-safe.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                displayName: t ? t("question4page:services.options.warranty-extension.title") : "",
                value: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                icon: "",
                tooltip: t ? t("question4page:services.options.warranty-extension.description") : "",
                ariaLabel: t ? t("question4page:services.options.warranty-extension.ariaLabel") : "",
                link: t ? t("question4page:services.options.warranty-extension.link") : "",
                textLink: t ? t("question4page:services.options.warranty-extension.textLink") : "",
            },
        ],
        seat: [
            {
                id: AdditionalProductType.TIRE_SERVICE,
                displayName: t ? t("question4page:services.options.tire-service.title") : "",
                value: AdditionalProductType.TIRE_SERVICE,
                icon: "",
                tooltip: t ? t("question4page:services.options.tire-service.description") : "",
                ariaLabel: t ? t("question4page:services.options.tire-service.ariaLabel") : "",
            },
            {
                id: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                displayName: t ? t("question4page:services.options.credit-protection-insurance.title") : "",
                value: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.credit-protection-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.credit-protection-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.credit-protection-insurance.link") : "",
                textLink: t ? t("question4page:services.options.credit-protection-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.MAINTENANCE,
                displayName: t ? t("question4page:services.options.service-and-inspection.title") : "",
                value: AdditionalProductType.MAINTENANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.service-and-inspection.description") : "",
                ariaLabel: t ? t("question4page:services.options.service-and-inspection.ariaLabel") : "",
                link: t ? t("question4page:services.options.service-and-inspection.link") : "",
                textLink: t ? t("question4page:services.options.service-and-inspection.textLink") : "",
            },
            {
                id: AdditionalProductType.MOTOR_INSURANCE,
                displayName: t ? t("question4page:services.options.motor-insurance.title") : "",
                value: AdditionalProductType.MOTOR_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.motor-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.motor-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.motor-insurance.link") : "",
                textLink: t ? t("question4page:services.options.motor-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_DRIVER,
                displayName: t ? t("question4page:services.options.safe-in-motion.title") : "",
                value: AdditionalProductType.INSURANCE_DRIVER,
                icon: "",
                tooltip: t ? t("question4page:services.options.safe-in-motion.description") : "",
                ariaLabel: t ? t("question4page:services.options.safe-in-motion.ariaLabel") : "",
                link: t ? t("question4page:services.options.safe-in-motion.link") : "",
                textLink: t ? t("question4page:services.options.safe-in-motion.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                displayName: t ? t("question4page:services.options.gap-events-insurance.title") : "",
                value: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.gap-events-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.gap-events-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.gap-events-insurance.link") : "",
                textLink: t ? t("question4page:services.options.gap-events-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_IDENTIFICATION,
                displayName: t ? t("question4page:services.options.securi-code.title") : "",
                value: AdditionalProductType.VEHICLE_IDENTIFICATION,
                icon: "",
                tooltip: t ? t("question4page:services.options.securi-code.description") : "",
                ariaLabel: t ? t("question4page:services.options.securi-code.ariaLabel") : "",
                link: t ? t("question4page:services.options.securi-code.link") : "",
                textLink: t ? t("question4page:services.options.securi-code.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                displayName: t ? t("question4page:services.options.capital-safe.title") : "",
                value: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.capital-safe.description") : "",
                ariaLabel: t ? t("question4page:services.options.capital-safe.ariaLabel") : "",
                link: t ? t("question4page:services.options.capital-safe.link") : "",
                textLink: t ? t("question4page:services.options.capital-safe.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                displayName: t ? t("question4page:services.options.warranty-extension.title") : "",
                value: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                icon: "",
                tooltip: t ? t("question4page:services.options.warranty-extension.description") : "",
                ariaLabel: t ? t("question4page:services.options.warranty-extension.ariaLabel") : "",
                link: t ? t("question4page:services.options.warranty-extension.link") : "",
                textLink: t ? t("question4page:services.options.warranty-extension.textLink") : "",
            },
        ],
        audi: [
            {
                id: AdditionalProductType.TIRE_SERVICE,
                displayName: t ? t("question4page:services.options.tire-service.title") : "",
                value: AdditionalProductType.TIRE_SERVICE,
                icon: "",
                tooltip: t ? t("question4page:services.options.tire-service.description") : "",
                ariaLabel: t ? t("question4page:services.options.tire-service.ariaLabel") : "",
            },
            {
                id: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                displayName: t ? t("question4page:services.options.credit-protection-insurance.title") : "",
                value: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.credit-protection-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.credit-protection-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.credit-protection-insurance.link") : "",
                textLink: t ? t("question4page:services.options.credit-protection-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.MAINTENANCE,
                displayName: t ? t("question4page:services.options.service-and-inspection.title") : "",
                value: AdditionalProductType.MAINTENANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.service-and-inspection.description") : "",
                ariaLabel: t ? t("question4page:services.options.service-and-inspection.ariaLabel") : "",
                link: t ? t("question4page:services.options.service-and-inspection.link") : "",
                textLink: t ? t("question4page:services.options.service-and-inspection.textLink") : "",
            },
            {
                id: AdditionalProductType.MOTOR_INSURANCE,
                displayName: t ? t("question4page:services.options.motor-insurance.title") : "",
                value: AdditionalProductType.MOTOR_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.motor-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.motor-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.motor-insurance.link") : "",
                textLink: t ? t("question4page:services.options.motor-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_DRIVER,
                displayName: t ? t("question4page:services.options.safe-in-motion.title") : "",
                value: AdditionalProductType.INSURANCE_DRIVER,
                icon: "",
                tooltip: t ? t("question4page:services.options.safe-in-motion.description") : "",
                ariaLabel: t ? t("question4page:services.options.safe-in-motion.ariaLabel") : "",
                link: t ? t("question4page:services.options.safe-in-motion.link") : "",
                textLink: t ? t("question4page:services.options.safe-in-motion.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                displayName: t ? t("question4page:services.options.gap-events-insurance.title") : "",
                value: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.gap-events-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.gap-events-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.gap-events-insurance.link") : "",
                textLink: t ? t("question4page:services.options.gap-events-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_IDENTIFICATION,
                displayName: t ? t("question4page:services.options.securi-code.title") : "",
                value: AdditionalProductType.VEHICLE_IDENTIFICATION,
                icon: "",
                tooltip: t ? t("question4page:services.options.securi-code.description") : "",
                ariaLabel: t ? t("question4page:services.options.securi-code.ariaLabel") : "",
                link: t ? t("question4page:services.options.securi-code.link") : "",
                textLink: t ? t("question4page:services.options.securi-code.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                displayName: t ? t("question4page:services.options.capital-safe.title") : "",
                value: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.capital-safe.description") : "",
                ariaLabel: t ? t("question4page:services.options.capital-safe.ariaLabel") : "",
                link: t ? t("question4page:services.options.capital-safe.link") : "",
                textLink: t ? t("question4page:services.options.capital-safe.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                displayName: t ? t("question4page:services.options.warranty-extension.title") : "",
                value: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                icon: "",
                tooltip: t ? t("question4page:services.options.warranty-extension.description") : "",
                ariaLabel: t ? t("question4page:services.options.warranty-extension.ariaLabel") : "",
                link: t ? t("question4page:services.options.warranty-extension.link") : "",
                textLink: t ? t("question4page:services.options.warranty-extension.textLink") : "",
            },
        ],
        vw: [
            {
                id: AdditionalProductType.TIRE_SERVICE,
                displayName: t ? t("question4page:services.options.tire-service.title") : "",
                value: AdditionalProductType.TIRE_SERVICE,
                icon: "",
                tooltip: t ? t("question4page:services.options.tire-service.description") : "",
                ariaLabel: t ? t("question4page:services.options.tire-service.ariaLabel") : "",
            },
            {
                id: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                displayName: t ? t("question4page:services.options.credit-protection-insurance.title") : "",
                value: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.credit-protection-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.credit-protection-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.credit-protection-insurance.link") : "",
                textLink: t ? t("question4page:services.options.credit-protection-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.MAINTENANCE,
                displayName: t ? t("question4page:services.options.service-and-inspection.title") : "",
                value: AdditionalProductType.MAINTENANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.service-and-inspection.description") : "",
                ariaLabel: t ? t("question4page:services.options.service-and-inspection.ariaLabel") : "",
                link: t ? t("question4page:services.options.service-and-inspection.link") : "",
                textLink: t ? t("question4page:services.options.service-and-inspection.textLink") : "",
            },
            {
                id: AdditionalProductType.MOTOR_INSURANCE,
                displayName: t ? t("question4page:services.options.motor-insurance.title") : "",
                value: AdditionalProductType.MOTOR_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.motor-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.motor-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.motor-insurance.link") : "",
                textLink: t ? t("question4page:services.options.motor-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_DRIVER,
                displayName: t ? t("question4page:services.options.safe-in-motion.title") : "",
                value: AdditionalProductType.INSURANCE_DRIVER,
                icon: "",
                tooltip: t ? t("question4page:services.options.safe-in-motion.description") : "",
                ariaLabel: t ? t("question4page:services.options.safe-in-motion.ariaLabel") : "",
                link: t ? t("question4page:services.options.safe-in-motion.link") : "",
                textLink: t ? t("question4page:services.options.safe-in-motion.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                displayName: t ? t("question4page:services.options.gap-events-insurance.title") : "",
                value: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.gap-events-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.gap-events-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.gap-events-insurance.link") : "",
                textLink: t ? t("question4page:services.options.gap-events-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_IDENTIFICATION,
                displayName: t ? t("question4page:services.options.securi-code.title") : "",
                value: AdditionalProductType.VEHICLE_IDENTIFICATION,
                icon: "",
                tooltip: t ? t("question4page:services.options.securi-code.description") : "",
                ariaLabel: t ? t("question4page:services.options.securi-code.ariaLabel") : "",
                link: t ? t("question4page:services.options.securi-code.link") : "",
                textLink: t ? t("question4page:services.options.securi-code.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                displayName: t ? t("question4page:services.options.capital-safe.title") : "",
                value: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.capital-safe.description") : "",
                ariaLabel: t ? t("question4page:services.options.capital-safe.ariaLabel") : "",
                link: t ? t("question4page:services.options.capital-safe.link") : "",
                textLink: t ? t("question4page:services.options.capital-safe.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                displayName: t ? t("question4page:services.options.warranty-extension.title") : "",
                value: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                icon: "",
                tooltip: t ? t("question4page:services.options.warranty-extension.description") : "",
                ariaLabel: t ? t("question4page:services.options.warranty-extension.ariaLabel") : "",
                link: t ? t("question4page:services.options.warranty-extension.link") : "",
                textLink: t ? t("question4page:services.options.warranty-extension.textLink") : "",
            },
        ],
        vwn: [
            {
                id: AdditionalProductType.TIRE_SERVICE,
                displayName: t ? t("question4page:services.options.tire-service.title") : "",
                value: AdditionalProductType.TIRE_SERVICE,
                icon: "",
                tooltip: t ? t("question4page:services.options.tire-service.description") : "",
                ariaLabel: t ? t("question4page:services.options.tire-service.ariaLabel") : "",
            },
            {
                id: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                displayName: t ? t("question4page:services.options.credit-protection-insurance.title") : "",
                value: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.credit-protection-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.credit-protection-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.credit-protection-insurance.link") : "",
                textLink: t ? t("question4page:services.options.credit-protection-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.MAINTENANCE,
                displayName: t ? t("question4page:services.options.service-and-inspection.title") : "",
                value: AdditionalProductType.MAINTENANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.service-and-inspection.description") : "",
                ariaLabel: t ? t("question4page:services.options.service-and-inspection.ariaLabel") : "",
                link: t ? t("question4page:services.options.service-and-inspection.link") : "",
                textLink: t ? t("question4page:services.options.service-and-inspection.textLink") : "",
            },
            {
                id: AdditionalProductType.MOTOR_INSURANCE,
                displayName: t ? t("question4page:services.options.motor-insurance.title") : "",
                value: AdditionalProductType.MOTOR_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.motor-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.motor-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.motor-insurance.link") : "",
                textLink: t ? t("question4page:services.options.motor-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_DRIVER,
                displayName: t ? t("question4page:services.options.safe-in-motion.title") : "",
                value: AdditionalProductType.INSURANCE_DRIVER,
                icon: "",
                tooltip: t ? t("question4page:services.options.safe-in-motion.description") : "",
                ariaLabel: t ? t("question4page:services.options.safe-in-motion.ariaLabel") : "",
                link: t ? t("question4page:services.options.safe-in-motion.link") : "",
                textLink: t ? t("question4page:services.options.safe-in-motion.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                displayName: t ? t("question4page:services.options.gap-events-insurance.title") : "",
                value: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.gap-events-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.gap-events-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.gap-events-insurance.link") : "",
                textLink: t ? t("question4page:services.options.gap-events-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_IDENTIFICATION,
                displayName: t ? t("question4page:services.options.securi-code.title") : "",
                value: AdditionalProductType.VEHICLE_IDENTIFICATION,
                icon: "",
                tooltip: t ? t("question4page:services.options.securi-code.description") : "",
                ariaLabel: t ? t("question4page:services.options.securi-code.ariaLabel") : "",
                link: t ? t("question4page:services.options.securi-code.link") : "",
                textLink: t ? t("question4page:services.options.securi-code.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                displayName: t ? t("question4page:services.options.capital-safe.title") : "",
                value: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.capital-safe.description") : "",
                ariaLabel: t ? t("question4page:services.options.capital-safe.ariaLabel") : "",
                link: t ? t("question4page:services.options.capital-safe.link") : "",
                textLink: t ? t("question4page:services.options.capital-safe.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                displayName: t ? t("question4page:services.options.warranty-extension.title") : "",
                value: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                icon: "",
                tooltip: t ? t("question4page:services.options.warranty-extension.description") : "",
                ariaLabel: t ? t("question4page:services.options.warranty-extension.ariaLabel") : "",
                link: t ? t("question4page:services.options.warranty-extension.link") : "",
                textLink: t ? t("question4page:services.options.warranty-extension.textLink") : "",
            },
        ],
        skoda: [
            {
                id: AdditionalProductType.TIRE_SERVICE,
                displayName: t ? t("question4page:services.options.tire-service.title") : "",
                value: AdditionalProductType.TIRE_SERVICE,
                icon: "",
                tooltip: t ? t("question4page:services.options.tire-service.description") : "",
                ariaLabel: t ? t("question4page:services.options.tire-service.ariaLabel") : "",
            },
            {
                id: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                displayName: t ? t("question4page:services.options.credit-protection-insurance.title") : "",
                value: AdditionalProductType.CREDIT_PROTECTION_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.credit-protection-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.credit-protection-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.credit-protection-insurance.link") : "",
                textLink: t ? t("question4page:services.options.credit-protection-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.MAINTENANCE,
                displayName: t ? t("question4page:services.options.service-and-inspection.title") : "",
                value: AdditionalProductType.MAINTENANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.service-and-inspection.description") : "",
                ariaLabel: t ? t("question4page:services.options.service-and-inspection.ariaLabel") : "",
                link: t ? t("question4page:services.options.service-and-inspection.link") : "",
                textLink: t ? t("question4page:services.options.service-and-inspection.textLink") : "",
            },
            {
                id: AdditionalProductType.MOTOR_INSURANCE,
                displayName: t ? t("question4page:services.options.motor-insurance.title") : "",
                value: AdditionalProductType.MOTOR_INSURANCE,
                icon: "",
                tooltip: t ? t("question4page:services.options.motor-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.motor-insurance.description") : "",
                link: t ? t("question4page:services.options.motor-insurance.link") : "",
                textLink: t ? t("question4page:services.options.motor-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_DRIVER,
                displayName: t ? t("question4page:services.options.safe-in-motion.title") : "",
                value: AdditionalProductType.INSURANCE_DRIVER,
                icon: "",
                tooltip: t ? t("question4page:services.options.safe-in-motion.description") : "",
                ariaLabel: t ? t("question4page:services.options.safe-in-motion.ariaLabel") : "",
                link: t ? t("question4page:services.options.safe-in-motion.link") : "",
                textLink: t ? t("question4page:services.options.safe-in-motion.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                displayName: t ? t("question4page:services.options.gap-events-insurance.title") : "",
                value: AdditionalProductType.INSURANCE_EVENT_COVERAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.gap-events-insurance.description") : "",
                ariaLabel: t ? t("question4page:services.options.gap-events-insurance.ariaLabel") : "",
                link: t ? t("question4page:services.options.gap-events-insurance.link") : "",
                textLink: t ? t("question4page:services.options.gap-events-insurance.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_IDENTIFICATION,
                displayName: t ? t("question4page:services.options.securi-code.title") : "",
                value: AdditionalProductType.VEHICLE_IDENTIFICATION,
                icon: "",
                tooltip: t ? t("question4page:services.options.securi-code.description") : "",
                ariaLabel: t ? t("question4page:services.options.securi-code.ariaLabel") : "",
                link: t ? t("question4page:services.options.securi-code.link") : "",
                textLink: t ? t("question4page:services.options.securi-code.textLink") : "",
            },
            {
                id: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                displayName: t ? t("question4page:services.options.capital-safe.title") : "",
                value: AdditionalProductType.INSURANCE_VEHICLE_TOTAL_DAMAGE,
                icon: "",
                tooltip: t ? t("question4page:services.options.capital-safe.description") : "",
                ariaLabel: t ? t("question4page:services.options.capital-safe.ariaLabel") : "",
                link: t ? t("question4page:services.options.capital-safe.link") : "",
                textLink: t ? t("question4page:services.options.capital-safe.textLink") : "",
            },
            {
                id: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                displayName: t ? t("question4page:services.options.warranty-extension.title") : "",
                value: AdditionalProductType.VEHICLE_EXTENDED_WARRANTY,
                icon: "",
                tooltip: t ? t("question4page:services.options.warranty-extension.description") : "",
                ariaLabel: t ? t("question4page:services.options.warranty-extension.ariaLabel") : "",
                link: t ? t("question4page:services.options.warranty-extension.link") : "",
                textLink: t ? t("question4page:services.options.warranty-extension.textLink") : "",
            },
        ],
    };
    return ContractServices[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}

export function getContractServicesDisplayName(value: AdditionalProductType, t?: TFunction) {
    const transmission = getContractServices(t);

    return transmission.filter((x) => x.value === value)[0]?.displayName ?? "";
}

export function getDefaultMonthlyPayment(brand?: BrandType): number {
    const DefaultMonthlyPayment = {
        cupra: 150,
        seat: 150,
        audi: 150,
        vw: 150,
        vwn: 150,
        skoda: 150,
    };
    return DefaultMonthlyPayment[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}

export function getMinPower(brand?: BrandType): number {
    const getMinPower = {
        cupra: 70,
        seat: 70,
        audi: 85,
        vw: 70,
        vwn: 70,
        skoda: 70,
    };
    return getMinPower[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}

export function getMaxPower(brand?: BrandType): number {
    const MaxPower = {
        cupra: 290,
        seat: 290,
        audi: 680,
        vw: 290,
        vwn: 290,
        skoda: 290,
    };
    return MaxPower[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}

export function getDepositMinValue(brand?: BrandType): number {
    const Deposit = {
        cupra: 1000,
        seat: 1000,
        audi: 1000,
        vw: 1000,
        vwn: 1000,
        skoda: 1000,
    };
    return Deposit[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}

export function getDepositMaxValue(brand?: BrandType): number {
    const Deposit = {
        cupra: 20000,
        seat: 20000,
        audi: 20000,
        vw: 20000,
        vwn: 20000,
        skoda: 20000,
    };
    return Deposit[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}